import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/src/node_modules/.pnpm/next@15.5.15_@babel+core@7.26.10_@opentelemetry+api@1.9.1_babel-plugin-macros@3.1.0_rea_23b67ba2486c3d724374ff970b22220a/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(staitc-page)/klarna/components/faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(staitc-page)/klarna/components/klarna_DE.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/Image/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
